import { render } from "./UnitTypeDetails.vue?vue&type=template&id=52c4fe1a&scoped=true"
import script from "./UnitTypeDetails.vue?vue&type=script&lang=js"
export * from "./UnitTypeDetails.vue?vue&type=script&lang=js"

import "./UnitTypeDetails.vue?vue&type=style&index=0&id=52c4fe1a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c4fe1a"]])

export default __exports__